import Config from '../../config';
import {
  handleErrors,
  parseAsJson,
} from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';

export const addJob = async (jobType, formData) => await fetch(
  Config.endpoints.ADD_JOB
    .replace(/:jobType/, jobType), {
    method: 'POST',
    body: formData,
  }
)
  .then(handleErrors({ errorMessage: 'Adding to the queue failed' }))
  .then(parseAsJson);

export const fetchJobStatuses = async limit =>
  await fetch(`${Config.endpoints.FETCH_JOB_STATUSES}${limit ? `?limit=${limit}` : ''}`)
    .then(handleErrors({ errorMessage: 'Fetching statuses of jobs failed' }))
    .then(parseAsJson);

export const addJobOnMaster = async (jobType, enqueueJobData) => await fetch(
  Config.endpoints.ADD_JOB_ON_MASTER
    .replace(/:jobType/, jobType), {
    method: 'POST',
    body: JSON.stringify(enqueueJobData),
  }
)
  .then(handleErrors({ errorMessage: 'Adding to the queue failed' }))
  .then(parseAsJson);
